import React from "react"


function Navbar() {
	return (
		<>
			<nav>
				<div className="nav_wrapper">
					<h3 className="header">Portfolio</h3>
					<ul>
						<li><a href="https://github.com/Raajprajapati" target="_blank"><i className="fab fa-github-square"></i></a></li>
						<li><a href="https://raajprajapati.netlify.app/" target="_blank"><i className="fas fa-globe"></i></a></li>
					</ul>
				</div>
			</nav>
		</>
	)
}

export default Navbar
